const service = (() => {
  // Add comma after every thousand (US currency format)
  // Ref: https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
  const toUSANumberFormat = (num) => {
    if (typeof num === "number") {
      var parts = num.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    }
    return "";
  };

  // Calculate percent change between old and new value
  const calculatePercentChange = (oldValue, newValue) => {
    if (typeof oldValue !== "number" || typeof newValue !== "number") return;
    let change = (newValue - oldValue) / oldValue * 100;
    return Math.round(change * 100) / 100; // Rounding to 2 decimals
  };

  return { toUSANumberFormat, calculatePercentChange };
})();

export default service;



// WEBPACK FOOTER //
// ./src/services/managers/math.js